import { render, staticRenderFns } from "./LearningSettingsReminders.vue?vue&type=template&id=69c7a178&"
import script from "./LearningSettingsReminders.vue?vue&type=script&lang=js&"
export * from "./LearningSettingsReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports